export default {"id":"133541ac","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}